import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { Api as ApiIcon } from '@mui/icons-material';

interface ApiToggleButtonProps {
  isActive: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export const ApiToggleButton: React.FC<ApiToggleButtonProps> = ({
  isActive,
  onToggle,
  disabled = false
}) => {
  return (
    <Button
      variant="contained"
      onClick={onToggle}
      disabled={disabled}
      startIcon={<ApiIcon />}
      sx={{
        backgroundColor: isActive ? 'success.main' : 'error.main',
        color: 'white',
        '&:hover': {
          backgroundColor: isActive ? 'success.dark' : 'error.dark',
        },
        '&:disabled': {
          backgroundColor: 'grey.400',
          color: 'grey.600',
        },
        minWidth: 140,
        textTransform: 'none',
        fontWeight: 500,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="body2" sx={{ fontSize: '0.75rem', lineHeight: 1 }}>
          API Data
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.7rem', lineHeight: 1, opacity: 0.9 }}>
          {isActive ? 'Active' : 'Inactive'}
        </Typography>
      </Box>
    </Button>
  );
};
